/* eslint-disable max-len */
import * as config from '../config';
import { ProfileFieldsCDNSchema, TBIDConfigOfferTypes } from '../types';

export const getConfigUrl = (tbidConfigId: string, tbidConfigVersion: string, isOffer?: boolean): string => {
    const cdnHost = config.getCDNHost();

    // If `isOffer` is provided, use it to determine the path
    if (isOffer !== undefined) {
        const subpath = isOffer ? 'event' : 'auth';
        return `https://${cdnHost}/digital/@sfdc-www-emu/form-configurations/${tbidConfigVersion}/schemas/${subpath}/en-us/${tbidConfigId}.json`;
    }

    // Fallback logic based on specialConfigIds (can be removed once IDX starts passing isOffer)
    const specialConfigIds = Object.values(TBIDConfigOfferTypes);
    const subpath = specialConfigIds.includes(tbidConfigId as TBIDConfigOfferTypes) ? 'event' : 'auth';

    return `https://${cdnHost}/digital/@sfdc-www-emu/form-configurations/${tbidConfigVersion}/schemas/${subpath}/en-us/${tbidConfigId}.json`;
};

export const getTbidConfig = async (
    tbidConfigId: string,
    tbidConfigVersion: string,
    isOffer?: boolean
): Promise<ProfileFieldsCDNSchema | undefined> => {
    try {
        const requestUrl = getConfigUrl(tbidConfigId, tbidConfigVersion, isOffer);
        const response = await fetch(requestUrl);
        if (response.status !== 200) {
            throw new Error(`Unable to fetch tbid config parameter: ${response.status}`);
        }
        // if 200, return json response
        const json = await response.json();

        return json;
    } catch (error) {
        console.error('Error fetching partner config:', error);
        return undefined;
    }
};
